const globalConst = {
  state: {
    aggrs: [{
      value: '10', label: '等于'
    }, {
      value: '20', label: '不等于'
    }, {
      value: '30', label: '包含'
    }, {
      value: '50', label: '为空'
    }, {
      value: '60', label: '不为空'
    }],
    timeAggrs: [{
      value: '70', label: '选择日期范围'
    }, {
      value: '50', label: '为空'
    }, {
      value: '60', label: '不为空'
    }]
  }
}

export default globalConst
